<div
  class="flex w-full flex-col"
  [class.pb-8]="!hideList"
  [class.pb-4]="hideList"
>
  @if (videos?.length > 0) {
    @if (titulo) {
      <h2
        class="text-left text-base leading-snug font-medium text-brand-sextenary-pure"
      >
        {{ titulo }}
      </h2>
    }

    <div
      class="flex flex-col gap-10"
      [class.mt-4]="titulo"
      [class.lg:flex-row]="!hideList"
    >
      <div
        class="z-10 h-fit w-full min-w-0"
        [class.lg:sticky]="!hideList"
        [class.lg:top-20]="!hideList"
        [class.lg:flex-1]="!hideList"
        [class.max-w-5xl]="hideList"
      >
        <div
          #videoContainer
          data-shaka-player-container
          class="aspect-video w-full overflow-hidden rounded-md bg-neutral-low-pure shadow-md"
        >
          <video
            #videoPlayer
            class="size-full object-contain"
            controlsList="nodownload"
            allow="autoplay; fullscreen; picture-in-picture;"
          ></video>
        </div>
      </div>

      @if (!hideList) {
        <div class="relative flex-1 lg:max-w-xl">
          @if (canScrollUp) {
            <div
              class="pointer-events-none absolute top-0 right-0 left-0 z-20 hidden h-6 bg-linear-to-b from-white via-white/90 to-transparent lg:block"
            ></div>
          }

          <ul
            #videoList
            (scroll)="onListScroll($event)"
            class="relative space-y-4 divide-y divide-neutral-hight-light lg:-ml-4 lg:max-h-[60svh] lg:overflow-y-auto lg:pr-4"
          >
            @for (video of videos; track video.id) {
              <li
                class="flex items-center justify-between gap-12 pt-4 first:pt-0"
              >
                <div class="flex flex-1 items-center gap-3">
                  <button
                    (click)="forceUpdateVideoPlaying(video)"
                    class="group flex-1 cursor-pointer rounded-lg px-4 py-2 text-left text-base leading-6 outline-0 transition-all duration-150 disabled:cursor-not-allowed disabled:opacity-60 data-[is-current='true']:bg-brand-primary-lightest"
                    [attr.data-tracking-id]="
                      'serie-video-shaka-' + video.titulo
                    "
                    [attr.data-is-current]="
                      videoPlaying?.id === video.id ? 'true' : 'false'
                    "
                    [disabled]="renderListStatus() !== 'ready'"
                  >
                    <span
                      class="overflow-hidden font-medium text-ellipsis whitespace-nowrap text-neutral-low-pure underline-offset-2 group-hover:underline group-data-[is-current='true']:font-semibold group-data-[is-current='true']:text-brand-primary-pure group-enabled:hover:text-brand-primary-pure"
                    >
                      {{ video.titulo }}
                    </span>
                    <!-- Status text -->
                    @if (video.isDownloading) {
                      <span
                        class="ml-2 text-xs font-normal text-feedback-success-medium"
                        >{{ 'serie_video.downloading' | translate }}</span
                      >
                    } @else if (video.isInQueue) {
                      <span
                        class="ml-2 text-xs font-normal text-feedback-helper-medium"
                        >{{ 'serie_video.on_queue' | translate }}</span
                      >
                    } @else if (video.offlineUri) {
                      <span
                        class="ml-2 text-xs font-normal text-neutral-low-light"
                        >{{ 'serie_video.downloading' | translate }}</span
                      >
                    }
                  </button>
                </div>

                <div class="flex h-8 items-center justify-center gap-6">
                  @if (!hideShare) {
                    <button
                      class="flex size-8 cursor-pointer items-center justify-center rounded-full border-0 bg-brand-sextenary-lightest p-0 text-[0] text-neutral-low-dark shadow-lg transition-all duration-150 enabled:hover:bg-brand-sextenary-light enabled:hover:text-white disabled:cursor-not-allowed"
                      trackingId="CriarLink"
                      [disabled]="
                        video.share?.loading || renderListStatus() !== 'ready'
                      "
                      (click)="onShareLink(video)"
                    >
                      @if (video.share?.loading) {
                        <commons-loader />
                      } @else {
                        <ng-icon name="featherLink2" size="16" />
                      }
                    </button>
                  }

                  @if (!isIOSOperatingSystem) {
                    <div
                      class="relative flex size-8 items-center justify-center rounded-full transition-all duration-300"
                    >
                      <!-- Círculo de progresso para download ativo -->
                      @if (video.isDownloading) {
                        <div
                          class="absolute size-8 rounded-full transition-all duration-500 ease-in"
                          [style.background]="
                            'conic-gradient(#10b981 ' +
                            ((video?.download$ | async)?.progress || 0) +
                            '%,#e5e7eb ' +
                            ((video?.download$ | async)?.progress || 0) +
                            '%)'
                          "
                        ></div>
                      }

                      <!-- Background amarelo para itens na fila -->
                      @if (video.isInQueue && !video.isDownloading) {
                        <div
                          class="absolute size-8 animate-pulse rounded-full border-2 border-dashed border-yellow-400 bg-yellow-100 transition-all duration-500 ease-in"
                        ></div>
                      }

                      <!-- Botão de cancelar - mais visível -->
                      @if (video.isDownloading || video.isInQueue) {
                        <button
                          class="relative z-20 flex h-7 w-7 items-center justify-center rounded-full border-0 bg-feedback-warning-pure text-white shadow-lg transition-all duration-150 hover:scale-110 hover:bg-feedback-warning-medium"
                          (click)="onCancelDownload(video)"
                          [livTooltipTrigger]="
                            'messages.cancel_downloading' | translate
                          "
                          livTooltipTriggerPlacement="top"
                          livTooltipTriggerShowDelay="100"
                          livTooltipTriggerHideDelay="50"
                        >
                          <ng-icon name="featherX" size="14" />
                        </button>
                      } @else {
                        <!-- Botão de download normal -->
                        <button
                          class="relative flex size-8 items-center justify-center rounded-full border-0 text-white shadow-lg transition-all duration-300 disabled:cursor-default"
                          [ngClass]="{
                            'bg-brand-primary-pure hover:scale-105 hover:bg-brand-primary-dark':
                              !(
                                video.offlineUri ||
                                (video?.download$ | async)?.completed
                              ),
                            'bg-feedback-success-pure':
                              video.offlineUri ||
                              (video?.download$ | async)?.completed
                          }"
                          [disabled]="
                            video.offlineUri ||
                            (video?.download$ | async)?.completed
                          "
                          (click)="onDownload(video)"
                        >
                          @if (
                            video.offlineUri ||
                            (video?.download$ | async)?.completed
                          ) {
                            <ng-icon name="featherCheck" size="16" />
                          } @else {
                            <ng-icon name="featherDownload" size="16" />
                          }
                        </button>
                      }
                    </div>
                  }
                </div>
              </li>
            }
          </ul>

          <!-- Gradient shadow no final apenas quando há mais conteúdo - só no desktop -->
          @if (canScrollDown) {
            <div
              class="pointer-events-none absolute right-0 bottom-0 left-0 z-20 hidden h-6 bg-linear-to-t from-white via-white/90 to-transparent lg:block"
            ></div>
          }
        </div>
      }
    </div>
  } @else {
    <span class="text-base leading-6">
      {{ 'messages.no_videos' | translate }}
    </span>
  }
</div>
